import Image from 'next/image';
import React, { FC } from 'react';

import { HOW_IT_WORKS_URL } from '@/shared/constants/paths';
import { useTranslate } from '@/shared/hooks/use-translate';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { Layout } from '@/shared/ui/layout';

import * as Styled from './styled';

export const HowWorkServiceBanner: FC = () => {
    const { t } = useTranslate();

    return (
        <Styled.Wrapper>
            <Layout.Content>
                <Breadcrumbs
                    breadcrumbs={[
                        { name: t('Главная'), url: '/' },
                        { name: t('Как работает наш сервис'), url: HOW_IT_WORKS_URL },
                    ]}
                />
                <Styled.HowWorkServiceBannerContainer>
                    <Styled.HowWorkServiceBannerLeft>
                        <Styled.HowWorkServiceBannerLeftText>
                            {t('Планируете купить дорогой товар и хотите провести тест-драйв?')}
                        </Styled.HowWorkServiceBannerLeftText>
                        <Styled.HowWorkServiceBannerLeftText>
                            {t('Хотите приобрести GoPro для записи впечатлений, но не хотите тратить 400 000 ₸?')}
                            <span>
                                <Image fill src="/static/icons/thoughtful_smile.png" alt="thoughtful_smile" priority />
                            </span>
                        </Styled.HowWorkServiceBannerLeftText>
                        <Styled.HowWorkServiceBannerLeftText>
                            {t('Сдали ноутбук в ремонт, а нужно срочно сдать проект?')}
                            <span>
                                <Image fill src="/static/icons/thoughtful_smile.png" alt="thoughtful_smile" priority />
                            </span>
                        </Styled.HowWorkServiceBannerLeftText>
                        <Styled.HowWorkServiceBannerLeftText>
                            {t('Делаете ремонт дома и временно нужны инструменты?')}
                        </Styled.HowWorkServiceBannerLeftText>
                    </Styled.HowWorkServiceBannerLeft>
                    <Styled.HowWorkServiceBannerRight>
                        <span>
                            <Image fill src="/static/images/cat_laptop.png" alt="laptop" priority />
                        </span>
                        <span>
                            <Image fill src="/static/images/cat_phones.png" alt="phones" priority />
                        </span>
                        <span>
                            <Image fill src="/static/images/cat_photos_videos.png" alt="photos and videos" priority />
                        </span>
                    </Styled.HowWorkServiceBannerRight>
                </Styled.HowWorkServiceBannerContainer>
            </Layout.Content>
        </Styled.Wrapper>
    );
};
